<template>
  <div class="m_goodscollect">
    <mt-header title="展商收藏">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        返回
      </span>
    </mt-header>
    展品收藏开发中，敬情期待......
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>